// extracted by mini-css-extract-plugin
export default {"psai_spin_dot":"PSAISpinDot_psai_spin_dot__6VfZL"};